import React from 'react';
import * as styles from './styles.css';
import { Body1 } from '@cian/ui-kit';
import clsx from 'clsx';

export interface IPeculiarityRowProps {
  title: string | null;
  isMobile?: boolean;
}

export function PeculiarityRow({ title, isMobile }: IPeculiarityRowProps) {
  return (
    <div className={clsx(styles['container'], isMobile && styles['mobile-container'])}>
      <Body1>{title}</Body1>
    </div>
  );
}
